import styled, {keyframes} from "styled-components";
import {FlexContainer} from "../../../styled";

export const Nav = styled.nav`
    margin: 0;
    height: fit-content;
    ${props => props.fontSize && `li *{font-size: ${props.fontSize};}`}
    >div{
        padding-top: .5rem;
        margin-bottom: .5rem;
    }
    h5 {
        margin: .9rem 0;
    }
    >div >div:first-child >*{
        height: fit-content;
        background-color: #fdfdfd; 
        &:not(:first-child){
            margin-top: .75rem;
        }
        border-radius: 5px;  
        overflow: hidden;
        ul {
            margin-bottom: 0!important;
        }
    }`
export const ListContainer = styled.ul` 
        background-color: ${props => props.theme.bg};
        padding: 0 .1rem;
        li{
            border-radius: 5px;
            width: 100%;
            min-height: 33px;
            padding: 6px 15px;
            span {
                color: #544A66;
                font-size: .875rem;
            }
            &+ li{
                margin-top: 9px;
            }
            p {
                margin-left: auto;
                color: inherit;
                width: 25px;
                text-align: center;
            }
            &.active{
                span{
                    font-weight: bold;
                    color: #544A66;
                }
                p{
                    font-weight: bold;
                    color: #544A66;
                }
            }
        } 
`
export const ContainerQueue = styled(FlexContainer)`
    width: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    flex-flow: column;
    height: fit-content;
    overflow:hidden;
    color: ${props => props.theme.text};
    >input {
        display: none;
    }
    
    label {
        display: none;
        font-size: .625rem;
        justify-content: space-between;
        >svg {
            height: .625rem;
        }
    }
    @media screen and (max-width: 680px) {
        label {
            display: flex;
            padding: 6px 15px;
            font-size: .875rem;
            font-weight: bold;
            margin: 0 0 8px;
            > .less {
                display: none;
            }
        }
        >input:checked + ${Nav} {
            ${ListContainer} {
                display: block;
            }
            label{
                .less {
                    display: block;
                }
                .more {
                    display: none;
                }
            }
        }
        ${Nav} h5,${Nav} ${ListContainer}, ${Nav} ${ListContainer} .active{
            display: none;
        }
    }
    
    span { color: inherit;}
    > div{ color: ${props => props.theme.bg};}
    nav ul {
        border-bottom: 0;
        margin-bottom: 5px;
        background-color: ${props => props.theme.bg}; 
    }
    position: relative;`
export const blink = keyframes`
    0% {left: 0; top: 0;width: 50px;}
    25% {left: 100%; top: 0; width: 3px;}
    50% {left: 100%; top: 100%;width: 50px;}
    75% {left: 0; top: 100%;width: 3px;}
    100% {left: 0; top: 0; width: 3px;} 
`
export const blinkNew = keyframes`
    0% {left: 0; top: 0;width: 50px;}
    25% {left: calc(100% - 3px); top: 0; width: 3px;}
    50% {left: 100%; top: 100%;width: 50px;}
    75% {left: 0; top: 100%;width: 3px;}
    100% {left: 0; top: 0; width: 3px;} 
`
export const blinkSla = keyframes`
    0% {left: 0; top: 0;width: 50px;}
    25% {left: 100%; top: 0; width: 3px;}
    50% {left: 100%; top: 100%;width: 50px;}
    75% {left: 0; top: 100%;width: 3px;}
    100% {left: 0; top: 0; width: 3px;} 
`


